import 'core-js/modules/es.object.assign.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { styled, Stack, spacing, withUtility, useIsMobile, useUtility, Text } from '@hub-la/design-system';
import { Thumbnail } from '@hub-la/fe-thumbnail';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import { alpha } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useGetPagination } from '../../hooks/use-get-pagination.js';

let _ = t => t,
  _t2;
const Card = styled(Stack)(_t2 || (_t2 = _`
  cursor: pointer;
  width: 100%;
  height: 56px;
  border-radius: 4px;
  flex-direction: row;
  padding: ${0};
  align-items: center;
  background-color: ${0};
`), spacing(2), withUtility(({
  palette
}) => alpha(palette('onSurface'), 0.1)));
const SidebarHeader = ({
  productId,
  isBeta: _isBeta = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
  const history = useHistory();
  const isMobile = useIsMobile();
  const {
    palette
  } = useUtility();
  const {
    getPagination
  } = useGetPagination({
    productId
  }, _isBeta);
  const {
    t
  } = useTranslation();
  const handleClick = postId => () => {
    window.scrollTo(0, 0);
    history.push(`/post/${postId}`);
  };
  const paginationData = getPagination();
  const hasNext = !!(paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost);
  const hasPrevious = !!(paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    jsx(Fragment, {
      children: (hasNext || hasPrevious) && jsxs(Stack, Object.assign({
        "data-testid": "sidebar-header-controls",
        flexDirection: "row",
        width: "100%",
        px: [0, 0, 6],
        pt: 6,
        bgcolor: !isMobile ? palette('surface') : undefined
      }, {
        children: [hasPrevious && jsxs(Card, Object.assign({
          marginRight: hasNext ? 2 : 0,
          onClick: handleClick((_b = (_a = paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '')
        }, {
          children: [jsx(Stack, Object.assign({
            marginRight: 2
          }, {
            children: jsx(SkipPreviousIcon, {
              sx: {
                fontSize: 20
              }
            })
          })), jsx(Thumbnail, {
            width: 40,
            height: 40,
            asset: (_d = (_c = paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost) === null || _c === void 0 ? void 0 : _c.customCover) !== null && _d !== void 0 ? _d : (_e = paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost) === null || _e === void 0 ? void 0 : _e.cover,
            hasProgressBar: false,
            lockContent: new Date((_g = (_f = paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost) === null || _f === void 0 ? void 0 : _f.releaseAt) !== null && _g !== void 0 ? _g : 0) > new Date()
          }), jsxs(Stack, Object.assign({
            marginLeft: 3
          }, {
            children: [jsx(Text, Object.assign({
              variant: "caption",
              color: "onSurface"
            }, {
              children: t('postDetail.sidebar.header.previous')
            })), !hasNext && jsx(Text, Object.assign({
              variant: "body2",
              color: "onSurface"
            }, {
              children: (_h = paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost) === null || _h === void 0 ? void 0 : _h.title
            }))]
          }))]
        }), (_j = paginationData === null || paginationData === void 0 ? void 0 : paginationData.previousPost) === null || _j === void 0 ? void 0 : _j.id), hasNext && jsxs(Card, Object.assign({
          marginLeft: hasPrevious ? 2 : 0,
          onClick: handleClick((_l = (_k = paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost) === null || _k === void 0 ? void 0 : _k.id) !== null && _l !== void 0 ? _l : '')
        }, {
          children: [jsx(Thumbnail, {
            width: 40,
            height: 40,
            asset: (_o = (_m = paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost) === null || _m === void 0 ? void 0 : _m.customCover) !== null && _o !== void 0 ? _o : (_p = paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost) === null || _p === void 0 ? void 0 : _p.cover,
            hasProgressBar: false,
            lockContent: new Date((_r = (_q = paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost) === null || _q === void 0 ? void 0 : _q.releaseAt) !== null && _r !== void 0 ? _r : 0) > new Date()
          }), jsxs(Stack, Object.assign({
            marginLeft: 3,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%"
          }, {
            children: [jsxs(Stack, {
              children: [jsx(Text, Object.assign({
                variant: "caption",
                color: "onSurface"
              }, {
                children: t('postDetail.sidebar.header.next')
              })), !hasPrevious && jsx(Text, Object.assign({
                variant: "body2",
                color: "onSurface"
              }, {
                children: (_s = paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost) === null || _s === void 0 ? void 0 : _s.title
              }))]
            }), jsx(Stack, Object.assign({
              marginLeft: 2
            }, {
              children: jsx(SkipNextIcon, {
                sx: {
                  fontSize: 20
                }
              })
            }))]
          }))]
        }), (_t = paginationData === null || paginationData === void 0 ? void 0 : paginationData.nextPost) === null || _t === void 0 ? void 0 : _t.id)]
      }))
    })
  );
};

export { SidebarHeader };
